import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
  transform(dict: Object): Array<any> {
    if (dict) {
      return Object.keys(dict).map(key => ({ key, value: dict[key] }));
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/pipes/keys.pipe.ts